"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevelNamebyNumber = exports.flpTransformQualificationToNumber = exports.getCircularReplacer = exports.chinesePQTransformLevelName = exports.flpTransformLevelName = exports.transformLevelName = exports.findCommonElements = exports.checkEmploymentFormRequiredFields = exports.canAvailCimaPqPremium = exports.substitute = exports.unionWithSubstitution = exports.replaceArrayPortion = exports.arrayToMap = exports.generateOktaCompliantPassword = exports.generateRandomPassword = exports.generateRandomInt = exports.cleanupOktaArrayClaim = exports.getSafeLocale = exports.getNasbaFieldOfStudy = exports.getCurrencySign = exports.centPriceToString = exports.formatPriceToTwoDecimalPoints = exports.toCentsFormat = exports.fromCentsFormat = exports.formatPrice = exports.startCase = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const crypto_1 = require("crypto");
const user_1 = require("../user");
const startCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.startCase = startCase;
const formatPrice = (amount, currency = 'USD') => {
    // IE fix for -($1010) below zero values wrapped in brackets
    const isLowerThan0 = amount < 0;
    const absAmount = Math.abs(amount);
    const minusPrefix = isLowerThan0 ? '-' : '';
    const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(absAmount);
    return `${minusPrefix}${formatted}`;
};
exports.formatPrice = formatPrice;
const fromCentsFormat = (n) => n / 100;
exports.fromCentsFormat = fromCentsFormat;
const toCentsFormat = (n) => n * 100;
exports.toCentsFormat = toCentsFormat;
const formatPriceToTwoDecimalPoints = (price, currency = 'USD') => {
    return price % 1 === 0
        ? `${new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
            minimumFractionDigits: 0,
        }).format(price)}`
        : (0, exports.formatPrice)(price, currency);
};
exports.formatPriceToTwoDecimalPoints = formatPriceToTwoDecimalPoints;
const centPriceToString = (price, currency = 'USD') => (0, exports.formatPriceToTwoDecimalPoints)(price / 100, currency).replace('.00', '');
exports.centPriceToString = centPriceToString;
const getCurrencySign = (currency = 'USD') => {
    var _a;
    return ((_a = new Intl.NumberFormat('en-US', { style: 'currency', currency }).formatToParts(1).find(x => x.type === 'currency')) === null || _a === void 0 ? void 0 : _a.value) || '$';
};
exports.getCurrencySign = getCurrencySign;
const getNasbaFieldOfStudy = (nasbaFieldOfStudy) => {
    return nasbaFieldOfStudy && nasbaFieldOfStudy.length ? nasbaFieldOfStudy.map((item) => item.label).sort() : null;
};
exports.getNasbaFieldOfStudy = getNasbaFieldOfStudy;
__exportStar(require("./StringHelpers"), exports);
__exportStar(require("./ObjectsAndArraysHelpers"), exports);
__exportStar(require("./associationRedirect"), exports);
const getSafeLocale = (propName, obj, locale) => {
    return obj && obj[propName] && obj[propName][locale] ? obj[propName][locale] : '';
};
exports.getSafeLocale = getSafeLocale;
const cleanupOktaArrayClaim = (roles) => roles ? roles.filter(Boolean).map((role) => role.trim()) : [];
exports.cleanupOktaArrayClaim = cleanupOktaArrayClaim;
const generateRandomInt = () => {
    const min = 0;
    const max = 1000000;
    const range = max - min + 1;
    // Calculate the number of bytes needed to represent all the values within the range
    const bitsNeeded = Math.ceil(Math.log2(range));
    const bytesNeeded = Math.ceil(bitsNeeded / 8);
    // Calculate the maximum value that can be generated within the given number of bytes
    const maxValue = Math.pow(256, bytesNeeded);
    let randomValue;
    do {
        const generatedRandomBytes = (0, crypto_1.randomBytes)(bytesNeeded);
        randomValue = generatedRandomBytes.readUIntBE(0, bytesNeeded);
    } while (randomValue >= maxValue - (maxValue % range));
    return min + (randomValue % range);
};
exports.generateRandomInt = generateRandomInt;
const generateRandomPassword = (customerId, customerEmail) => {
    const rnd = (0, crypto_1.randomBytes)(16).toString('hex');
    return (0, crypto_1.createHash)('sha256').update(`${customerId}:${customerEmail}:${rnd}`).digest('hex');
};
exports.generateRandomPassword = generateRandomPassword;
const generateOktaCompliantPassword = (customerId, customerEmail) => {
    const rnd = (0, crypto_1.randomBytes)(16).toString('hex');
    const hash = (0, crypto_1.createHash)('sha256').update(`${customerId}:${customerEmail}:${rnd}`).digest();
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[hash[0] % 26];
    const lower = 'abcdefghijklmnopqrstuvwxyz'[hash[1] % 26];
    const digit = '0123456789'[hash[2] % 10];
    const symbols = '!@#$%^&*()-_=+';
    const symbol = symbols[hash[3] % symbols.length];
    return `${hash.toString('hex')}${upper}${lower}${digit}${symbol}`;
};
exports.generateOktaCompliantPassword = generateOktaCompliantPassword;
__exportStar(require("./omitProps"), exports);
__exportStar(require("./ParentProductHelpers"), exports);
__exportStar(require("./PriceHelpers"), exports);
const arrayToMap = (array, keyField) => array.reduce((acc, element) => {
    acc[element[keyField]] = element;
    return acc;
}, {});
exports.arrayToMap = arrayToMap;
const replaceArrayPortion = (source, replaceFrom, equals) => source.reduce((acc, element) => acc.concat(replaceFrom.find(replaceWith => equals(element, replaceWith)) || element), []);
exports.replaceArrayPortion = replaceArrayPortion;
const unionWithSubstitution = (source, unionWith, equals) => {
    if (!source.length)
        return unionWith;
    if (!unionWith.length)
        return source;
    const leftUnion = (0, exports.substitute)(source, unionWith, equals);
    return unionWith.reduce((acc, element) => (acc.some(missing => equals(element, missing)) ? acc : acc.concat(element)), leftUnion);
};
exports.unionWithSubstitution = unionWithSubstitution;
const substitute = (source, replacement, equals) => source.reduce((acc, element) => acc.concat(replacement.find(replaceWith => equals(element, replaceWith)) || element), []);
exports.substitute = substitute;
// TODO - magic number will be move and for further checking
const canAvailCimaPqPremium = (accountingExperience, academiaExperience) => Number(accountingExperience) >= 6 || Number(academiaExperience) > 0;
exports.canAvailCimaPqPremium = canAvailCimaPqPremium;
const trimString = (value) => (value ? value.trim() : null);
const checkEmploymentFormRequiredFields = (requiredFieldsToCheck, employmentForm) => {
    if (employmentForm.organization) {
        return (requiredFieldsToCheck.filter((requiredFieldName) => {
            if (typeof requiredFieldName === 'object') {
                const [objectKeyName, objectValues] = Object.entries(requiredFieldName)[0];
                return (objectValues.filter((objectFieldName) => !trimString(employmentForm.organization[objectKeyName][objectFieldName])).length !== 0);
            }
            return !trimString(employmentForm.organization[requiredFieldName]);
        }).length === 0);
    }
    return false;
};
exports.checkEmploymentFormRequiredFields = checkEmploymentFormRequiredFields;
const findCommonElements = (array1, array2) => {
    return array1.some(item => array2.includes(item));
};
exports.findCommonElements = findCommonElements;
const transformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '1'
        ? user_1.LevelName.cert_ba
        : string.replace(/^\D+/g, '') === '2'
            ? user_1.LevelName.operational_OT
            : string.replace(/^\D+/g, '') === '3'
                ? user_1.LevelName.operational_CS
                : string.replace(/^\D+/g, '') === '4'
                    ? user_1.LevelName.management_OT
                    : string.replace(/^\D+/g, '') === '5'
                        ? user_1.LevelName.management_CS
                        : string.replace(/^\D+/g, '') === '6'
                            ? user_1.LevelName.strategic_OT
                            : string.replace(/^\D+/g, '') === '7'
                                ? user_1.LevelName.strategic_CS
                                : '';
    return title;
};
exports.transformLevelName = transformLevelName;
const flpTransformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '1'
        ? user_1.LevelNameFLP.Level_1
        : string.replace(/^\D+/g, '') === '2'
            ? user_1.LevelNameFLP.Level_2
            : string.replace(/^\D+/g, '') === '3'
                ? user_1.LevelNameFLP.Level_3
                : string.replace(/^\D+/g, '') === '4'
                    ? user_1.LevelNameFLP.Level_4
                    : string.replace(/^\D+/g, '') === '5'
                        ? user_1.LevelNameFLP.Level_5
                        : string.replace(/^\D+/g, '') === '6'
                            ? user_1.LevelNameFLP.Level_6
                            : string.replace(/^\D+/g, '') === '7'
                                ? user_1.LevelNameFLP.Level_7
                                : '';
    return title;
};
exports.flpTransformLevelName = flpTransformLevelName;
const chinesePQTransformLevelName = (string) => {
    const title = string.replace(/^\D+/g, '') === '6'
        ? user_1.LevelNameChinesePQ.Level_6
        : string.replace(/^\D+/g, '') === '7'
            ? user_1.LevelNameChinesePQ.Level_7
            : '';
    return title;
};
exports.chinesePQTransformLevelName = chinesePQTransformLevelName;
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
exports.getCircularReplacer = getCircularReplacer;
const flpTransformQualificationToNumber = (name) => {
    switch (name) {
        case mxp_schemas_1.ExemptionLevels.QualificationName.Cert:
        case mxp_schemas_1.ExemptionLevels.QualificationName.Business:
            return 1;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Operational:
            return 2;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Management:
            return 4;
        case mxp_schemas_1.ExemptionLevels.QualificationName.Strategic:
            return 6;
        default:
            return null;
    }
};
exports.flpTransformQualificationToNumber = flpTransformQualificationToNumber;
const getLevelNamebyNumber = (level, isFlp, isAicpaRegular, flpSwitchUpgrade) => {
    if (isFlp && Number(level) === mxp_schemas_1.ExemptionLevels.ExemptionLevels.Level_1) {
        return Number(level);
    }
    if (isFlp && Number(level) === mxp_schemas_1.ExemptionLevels.ExemptionLevels.Level_7 && isAicpaRegular) {
        return Number(level);
    }
    if (isFlp && flpSwitchUpgrade) {
        return Number(level);
    }
    if (isFlp && Number(level) % 2 !== 0) {
        return Number(level) - 1;
    }
    return Number(level);
};
exports.getLevelNamebyNumber = getLevelNamebyNumber;
//# sourceMappingURL=index.js.map